"use client";

import { useEffect } from "react";
import { installLinkedInInsight } from "./insight";

const linkedInPartnerId = process.env.NEXT_PUBLIC_LINKEDIN_PARTNER_ID;

/**
 * LinkedIn Insight Tag, for ad attribution and retargeting audiences.
 * Conversions are sent through `trackConversion` in `../../conversions`.
 */
export function AnalyticsScript() {
	useEffect(() => {
		if (!linkedInPartnerId) {
			return;
		}

		installLinkedInInsight(window, document, linkedInPartnerId);
	}, []);

	return null;
}
